import type { ListingStatusType, ParticipantStatusType } from "@repo/database";

export const SELLER_AGENT_BUYING_INQUIRY_PARTICIPATION_STATUSES: ParticipantStatusType[] =
  [
    "SELLER_AGENT_NEW_INQUIRY",
    "SELLER_AGENT_WAITING_FOR_INPUT",
    "SELLER_AGENT_VIEWING_SCHEDULED",
    "SELLER_AGENT_OFFER_SUBMITTED",
    "SELLER_AGENT_IN_NEGOTIATIONS",
    "SELLER_AGENT_UNDER_CONTRACT",
    "SELLER_AGENT_SALE_CLOSED",
  ] as const;

export type SellerAgentListingInquiryParticipantStatus =
  (typeof SELLER_AGENT_BUYING_INQUIRY_PARTICIPATION_STATUSES)[number];

export const BUYER_AGENT_BUYING_INQUIRY_PARTICIPATION_STATUSES: ParticipantStatusType[] =
  [
    "BUYER_AGENT_NEW_LEAD",
    "BUYER_AGENT_INQUIRY_SENT_TO_SELLER",
    "BUYER_AGENT_DETAILS_RECEIVED",
    "BUYER_AGENT_VIEWING_SCHEDULED",
    "BUYER_AGENT_PREPARING_OFFER",
    "BUYER_AGENT_NEGOTIATING",
    "BUYER_AGENT_OFFER_ACCEPTED",
    "BUYER_AGENT_PURCHASE_CLOSED",
  ] as const;

export type BuyerAgentListingInquiryParticipantStatus =
  (typeof BUYER_AGENT_BUYING_INQUIRY_PARTICIPATION_STATUSES)[number];

export const SELLER_AGENT_REPRESENTATION_PARTICIPANT_STATUSES: ParticipantStatusType[] =
  [
    "SELLER_AGENT_NEW_SELLER_LEAD",
    "SELLER_AGENT_CONTACT_ATTEMPTED",
    "SELLER_AGENT_CONTACTED_WAITING_FOR_SELLER",
    "SELLER_AGENT_SELLER_ENGAGED",
    "SELLER_AGENT_AGREEMENT_SENT",
    "SELLER_AGENT_AGREEMENT_SIGNED",
    "SELLER_AGENT_PREPARING_LISTING",
    "SELLER_AGENT_LISTING_PUBLISHED",
    "SELLER_AGENT_LEAD_LOST_NO_RESPONSE",
    "SELLER_AGENT_LEAD_LOST_SELLER_NOT_INTERESTED",
  ] as const;

export type SellerAgentParticipantStatus =
  (typeof SELLER_AGENT_REPRESENTATION_PARTICIPANT_STATUSES)[number];

export const BUYER_AGENT_REPRESENTATION_PARTICIPANT_STATUSES: ParticipantStatusType[] =
  [
    "BUYER_AGENT_NEW_BUYER_LEAD",
    "BUYER_AGENT_CONTACT_ATTEMPTED",
    "BUYER_AGENT_CONTACTED_WAITING_FOR_BUYER",
    "BUYER_AGENT_BUYER_ENGAGED",
    "BUYER_AGENT_AGREEMENT_SENT",
    "BUYER_AGENT_AGREEMENT_SIGNED",
    "BUYER_AGENT_SEARCHING_FOR_BUSINESS",
    "BUYER_AGENT_BUSINESS_IDENTIFIED_REVIEWING",
    "BUYER_AGENT_BUYER_TOURING_BUSINESSES",
    "BUYER_AGENT_BUYER_PREPARING_OFFER",
    "BUYER_AGENT_LEAD_LOST_NO_RESPONSE",
    "BUYER_AGENT_LEAD_LOST_BUYER_NOT_INTERESTED",
  ] as const;

export type BuyerAgentParticipantStatus =
  (typeof BUYER_AGENT_REPRESENTATION_PARTICIPANT_STATUSES)[number];

export const SELLER_INQUIRY_PARTICIPATION_STATUSES: ParticipantStatusType[] = [
  "SELLER_NEW_INQUIRY",
  "SELLER_WAITING_FOR_INPUT",
  "SELLER_VIEWING_SCHEDULED",
  "SELLER_OFFER_SUBMITTED",
  "SELLER_IN_NEGOTIATIONS",
  "SELLER_UNDER_CONTRACT",
  "SELLER_SALE_CLOSED",
] as const;

export type SellerInquiryParticipantStatus =
  (typeof SELLER_INQUIRY_PARTICIPATION_STATUSES)[number];

export const BUYER_INQUIRY_PARTICIPATION_STATUSES: ParticipantStatusType[] = [
  "BUYER_NEW_INQUIRY",
  "BUYER_VIEWING_SCHEDULED",
  "BUYER_OFFER_SUBMITTED",
  "BUYER_IN_NEGOTIATIONS",
  "BUYER_UNDER_CONTRACT",
  "BUYER_PURCHASE_CLOSED",
] as const;

export type BuyerInquiryParticipantStatus =
  (typeof BUYER_INQUIRY_PARTICIPATION_STATUSES)[number];

export const PUBLICLY_FILTERABLE_LISTING_STATUSES = [
  "FOR_SALE",
  "REVIEWING_OFFERS",
  "PENDING_CONTRACT",
  "UNDER_CONTRACT",
] as const satisfies ListingStatusType[];

export type PubliclyFilterableListingStatus =
  (typeof PUBLICLY_FILTERABLE_LISTING_STATUSES)[number];

export const PUBLICLY_VIEWABLE_LISTING_STATUSES = [
  ...PUBLICLY_FILTERABLE_LISTING_STATUSES,
  "SOLD",
] as const satisfies ListingStatusType[];

export type PubliclyViewableListingStatus =
  (typeof PUBLICLY_VIEWABLE_LISTING_STATUSES)[number];

export const ADMIN_SETTABLE_LISTING_STATUSES = [
  ...PUBLICLY_FILTERABLE_LISTING_STATUSES,
  "SOLD",
] as const satisfies ListingStatusType[];

export type AdminSettableListingStatus =
  (typeof ADMIN_SETTABLE_LISTING_STATUSES)[number];

export const ADMIN_FILTERABLE_LISTING_STATUSES = [
  "DRAFT",
  ...ADMIN_SETTABLE_LISTING_STATUSES,
  "ARCHIVED",
] as const satisfies ListingStatusType[];

export type AdminFilterableListingStatus =
  (typeof ADMIN_FILTERABLE_LISTING_STATUSES)[number];
